import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { useAuth } from "../lib/auth.jsx";
import { formatApiError } from "../lib/api";
import { toast } from "sonner";

export default function Login() {
  const { login } = useAuth();
  const nav = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");

  const submit = async (e) => {
    e.preventDefault();
    setError("");
    setLoading(true);
    try {
      await login(email, password);
      toast.success("Welcome back");
      nav("/");
    } catch (err) {
      setError(formatApiError(err));
    } finally {
      setLoading(false);
    }
  };

  const quickFill = (u) => {
    if (u === "dashan") { setEmail("dashan@taisang.com"); setPassword("dashan123"); }
    else { setEmail("jatin@taisang.com"); setPassword("jatin123"); }
  };

  return (
    <div className="min-h-screen bg-white flex">
      {/* Left brand rail */}
      <div className="hidden lg:flex flex-col justify-between w-[42%] bg-slate-50 border-r border-slate-200 p-12">
        <div className="flex items-center gap-3">
          <div className="w-11 h-11 rounded-xl bg-[#0055FF] flex items-center justify-center text-white font-bold text-lg">T</div>
          <div>
            <div className="font-display font-bold text-slate-900 text-lg leading-tight">Tai Sang</div>
            <div className="text-xs text-slate-500 leading-tight">Money Entry System</div>
          </div>
        </div>
        <div>
          <h1 className="font-display font-bold text-4xl text-slate-900 tracking-tight leading-[1.1]">
            One form.<br />Every transaction.
          </h1>
          <p className="mt-4 text-slate-600 text-base max-w-md">
            A single smart entry screen for money in, money out, expenses, transfers, and refunds — under one minute per record.
          </p>
        </div>
        <div className="text-xs text-slate-400">© Tai Sang · Internal use only</div>
      </div>

      {/* Right form */}
      <div className="flex-1 flex items-center justify-center px-6 py-10">
        <div className="w-full max-w-sm">
          <div className="lg:hidden flex items-center gap-2 mb-8">
            <div className="w-9 h-9 rounded-lg bg-[#0055FF] flex items-center justify-center text-white font-bold">T</div>
            <div>
              <div className="font-display font-bold text-slate-900 leading-tight">Tai Sang</div>
              <div className="text-[11px] text-slate-500 leading-tight">Money Entry System</div>
            </div>
          </div>

          <h2 className="font-display text-3xl font-bold text-slate-900 tracking-tight">Sign in</h2>
          <p className="text-slate-500 mt-2 text-sm">Enter your credentials to continue</p>

          <form onSubmit={submit} className="mt-8 space-y-4">
            <div>
              <label className="section-label block mb-1.5">Email</label>
              <input
                type="email"
                autoFocus
                required
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                data-testid="login-email"
                className="w-full h-13 px-4 text-base border border-slate-300 rounded-xl bg-white outline-none transition-colors"
                style={{ height: "52px" }}
                placeholder="you@taisang.com"
              />
            </div>
            <div>
              <label className="section-label block mb-1.5">Password</label>
              <input
                type="password"
                required
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                data-testid="login-password"
                className="w-full px-4 text-base border border-slate-300 rounded-xl bg-white outline-none transition-colors"
                style={{ height: "52px" }}
                placeholder="••••••••"
              />
            </div>

            {error && (
              <div className="text-sm text-red-600 bg-red-50 border border-red-200 rounded-lg px-3 py-2" data-testid="login-error">
                {error}
              </div>
            )}

            <button
              type="submit"
              disabled={loading}
              data-testid="login-submit"
              className="w-full bg-[#0055FF] hover:bg-[#0044CC] text-white font-semibold rounded-xl transition-colors disabled:opacity-60"
              style={{ height: "52px" }}
            >
              {loading ? "Signing in…" : "Sign in"}
            </button>
          </form>

          <div className="mt-6 pt-6 border-t border-slate-200">
            <div className="section-label mb-2">Quick sign in</div>
            <div className="flex gap-2">
              <button
                type="button"
                onClick={() => quickFill("dashan")}
                data-testid="quick-dashan"
                className="flex-1 border border-slate-200 rounded-lg px-3 py-2 text-sm text-slate-700 hover:bg-slate-50 transition-colors"
              >
                Dashan · Admin
              </button>
              <button
                type="button"
                onClick={() => quickFill("jatin")}
                data-testid="quick-jatin"
                className="flex-1 border border-slate-200 rounded-lg px-3 py-2 text-sm text-slate-700 hover:bg-slate-50 transition-colors"
              >
                Jatin · Accounts
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
